import { render, staticRenderFns } from "./MobilePushBanner.vue?vue&type=template&id=b82b62fc"
import script from "./MobilePushBanner.vue?vue&type=script&lang=js"
export * from "./MobilePushBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports